import { render, staticRenderFns } from "./ClientsList.vue?vue&type=template&id=49d57bbe&scoped=true&"
import script from "./ClientsList.vue?vue&type=script&lang=js&"
export * from "./ClientsList.vue?vue&type=script&lang=js&"
import style0 from "./ClientsList.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ClientsList.vue?vue&type=style&index=1&id=49d57bbe&lang=scss&scoped=true&"
import style2 from "./ClientsList.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d57bbe",
  null
  
)

export default component.exports